import { gql } from '@apollo/client';

export const FETCH_BILLPAY_ELIGIBILITY = gql`
  query Flex_FetchBillpayEligibility($utilityId: Int!) {
    utility(id: $utilityId) {
      id
      products {
        id
        key
      }
    }
  }
`;
